import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import Text from "components/Text";
import styles from "./AddStaff.module.scss";
import crossIcon from "assets/images/cross.svg";
import Empty from "components/Empty";
import ExpandableSearchBar from "accountOwner/pages/AddEvent/SchedulingAssistant/components/ExpandableSearchBar";

function EmploymentRoleSelectionModal({
  t,
  isModalOpen,
  setIsModalOpen,
  designations,
  selectedDesignationOption,
  selectDesignationOption,
}) {
  const [selectedVal, setSelectedVal] = useState(
    selectedDesignationOption || null
  );
  const [memberListSearch, setMemberListSearch] = useState("");
  const onSearch = (val) => {
    setMemberListSearch(val);
  };
  const designationList = useMemo(() => {
    const trimSearch = memberListSearch.trim().toLowerCase();
    if (trimSearch.length && designations?.length) {
      return (
        designations.filter((item) => {
          const fullName = item?.name.toLowerCase();
          return fullName.includes(trimSearch);
        }) || []
      );
    }
    return designations || [];
  }, [memberListSearch, designations]);
  return (
    <>
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        className={"modal-dialog-centered modal-width-660"}
        modalClassName="custom-modal"
      >
        <span className="close-btn" onClick={() => setIsModalOpen(false)}>
          <img src={crossIcon} alt="close" />
        </span>
        <ModalBody>
          <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
            <span className="modal-title-25">Select Role</span>
          </Text>
          <div className={`search-box w-100 ${styles["search-box"]}`}>
            <ExpandableSearchBar
              placeholder={t("accountOwner.searchByName")}
              searchValue={memberListSearch}
              setSearchValue={onSearch}
              expanded={true}
            />
          </div>

          {designationList && designationList.length > 0 ? (
            <ul
              className={
                styles["change-list"] +
            " "+
            styles["mb-40"] +
            " "+
                styles["modal-view-lists"]
              }
            >
              {designationList.map((item, key, arr) => (
                <li
                  key={key}
                  className={`${
                    arr.length - 1 === key ? "" : "border-bottom"
                  }`}
                >
                  <div className="ch-radio">
                    <label className="mr-5">
                      <input
                        type="radio"
                        readOnly
                        onClick={() => setSelectedVal(item)}
                        checked={item?.id === selectedVal?.id}
                        name="blockTimeslotAallDoctors"
                      />
                      <span>{item?.name} </span>
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <Empty Message="No role available for your selection" />
          )}
          <button
            className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
            title={t("apply")}
            onClick={() => {
              selectDesignationOption(selectedVal);
              setIsModalOpen(false);
              setSelectedVal(null);
            }}
          >
            {t("apply")}
          </button>
          <button
            className="button button-round button-border button-dark btn-mobile-link "
            onClick={() => {
              setIsModalOpen(false);
              setSelectedVal(null);
            }}
            title={t("cancel")}
          >
            {t("cancel")}
          </button>
        </ModalBody>
      </Modal>
    </>
  );
}

export default withTranslation()(EmploymentRoleSelectionModal);
